import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { WorksheetItemInput } from "DDD/action-objects/WorksheetItemUpdate";
import OrganizationProductTypeIdsOptions from "modules/OrganizationProductTypes/OrganizationProductTypeIdsOptions/OrganizationProductTypeIdsOptions";

export default function WorksheetProductTypeField({ isReadOnly }: { isReadOnly?: boolean }) {
  const { control } = useFormContext<WorksheetItemInput>();

  return (
    <OrganizationProductTypeIdsOptions sortByName>
      {({ organizationProductTypeIdsOptions, loading }) => (
        <Controller
          name="organizationProductTypeId"
          control={control}
          render={({ field }) => (
            <FormControl fullWidth size="small" disabled={isReadOnly || loading} required>
              <InputLabel id="worksheet-product-type-label">Product Type</InputLabel>
              <Select
                labelId="worksheet-product-type-label"
                label="Product Type"
                value={field.value ?? ""}
                onChange={(event) => field.onChange(event.target.value)}
              >
                {organizationProductTypeIdsOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        />
      )}
    </OrganizationProductTypeIdsOptions>
  );
}
